// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://omyqfeurofxjmyilwbws.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9teXFmZXVyb2Z4am15aWx3YndzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDIzMjczNjIsImV4cCI6MjA1NzkwMzM2Mn0.EKgusYBHl6iptBFfvMAPVPHKjydV_CbcrYgqze4sOl0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL, 
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      storage: localStorage,
      detectSessionInUrl: true,
      flowType: 'pkce',
      url: window.location.hostname === 'localhost' || window.location.hostname === 'sangre-fuerte.millev.com'
        ? `${window.location.origin}/auth/callback`
        : 'com.sangrefuerte.app://auth/callback'
    }
  }
);
